import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ThemeService } from './theme.service';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private environmentValues;

  constructor(private injector: Injector) { }

  async loadEnvConfig() {
    let http = this.injector.get(HttpClient);
    const jsonData = http.get('/assets/config/environments.json');
    this.environmentValues = await lastValueFrom(jsonData);
    let theme = this.injector.get(ThemeService);
    const themeJson = await lastValueFrom(theme.getThemesJson());
  }

  get envVariables() {
    if (this.environmentValues) this.environmentValues.webHost = this.checkUrlHost();
    return this.environmentValues;
  }

  checkUrlHost() {
    let url = window.location.href;
    let host = url.split('/')[2];
    return `${host}/api/`;
  }
}
